import { render, staticRenderFns } from "./MinusGreyIcon.vue?vue&type=template&id=12011b8e&scoped=true"
import script from "./MinusGreyIcon.vue?vue&type=script&lang=js"
export * from "./MinusGreyIcon.vue?vue&type=script&lang=js"
import style0 from "./MinusGreyIcon.vue?vue&type=style&index=0&id=12011b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12011b8e",
  null
  
)

export default component.exports